export function normalizeSize(input) {
  return input
    .trim()
    .replace(/^\((.*)\)$/, "$1")
    .replace(/\s+/g, "");
}
